import angular from 'angular';
import ViewFullGameInventoryWidgetComponent from './view-full-game-inventory-widget-component';

export default angular
  .module('view-full-game-inventory-widget', [])
  .component('viewFullGameInventoryWidget', new ViewFullGameInventoryWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/view-full-game-inventory/view-full-game-inventory-widget-module.js